import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const webModules = [
  "Weeks 1-4: HTML, CSS, JavaScript, Git/GitHub, back-end and data foundations",
  "Weeks 5-8: React fundamentals and advanced routing/state patterns",
  "Weeks 9-12: UI/UX design, media production, and 3D graphics foundations",
  "Weeks 13-16: Portfolio integration, career readiness, project management, capstone",
];

const electronicsModules = [
  "Weeks 1-5: Electricity, safety, circuits, microcontrollers, IoT connectivity",
  "Weeks 6-10: AI fundamentals, data workflows, ML, cloud integration, applied ethics",
  "Weeks 11-16: Workforce readiness, entrepreneurship, financial literacy, capstone",
];

const marketplaceTracks = [
  {
    title: "Programming and Development",
    text: "Custom websites, apps, and utility tools for local organizations and small businesses.",
  },
  {
    title: "AI, Data and Emerging Tech",
    text: "Chatbots, dashboards, and data-informed solutions that respond to community needs.",
  },
  {
    title: "Robotics, Electronics and Engineering",
    text: "Sensor-based systems, STEM kits, and IoT prototypes with practical local use cases.",
  },
  {
    title: "Design, Media and Creative Tech",
    text: "Branding assets, video, 3D models, and digital products for local clients.",
  },
  {
    title: "Workforce and Entrepreneurship Tech",
    text: "Portfolios, digital services, and business-support tools for small organizations.",
  },
];

const policies = [
  "Prorated refund policy with week-based withdrawal calculations",
  "Attendance and make-up standards for online and remote sessions",
  "Non-discrimination across all protected categories",
  "FERPA-aligned student data and privacy protections",
  "Written grievance and appeals process with response timelines",
  "Cohort capacity limits to preserve instructional quality",
];

function Projects() {
  return (
    <Container fluid className="project-section career-programs-page">
      <Container>
        <header className="career-hero">
          <p className="career-eyebrow">Career School Programs</p>
          <h1 className="career-title">Career Training Programs</h1>
          <p className="career-lead">
            Premium, workforce-aligned non-credit pathways designed for practical outcomes, measurable
            progress, and real project experience.
          </p>
          <div className="career-hero-actions">
            <a href="#enrollment-inquiry" className="custom-yellow-btn btn">Enrollment Inquiry</a>
            <Link to="/admissions" className="btn btn-primary">Admissions</Link>
            <Link to="/catalog" className="btn btn-primary">Catalog</Link>
            <Link to="/student-resources" className="btn btn-primary">Student Resources</Link>
          </div>
        </header>

        <section className="career-grid" aria-label="Program cards">
          <article className="career-card">
            <p className="career-card-kicker">Program 1</p>
            <h2>Web Development and Graphics Design</h2>
            <p>
              <strong>Type:</strong> Non-credit occupational training | <strong>Duration:</strong> 16 weeks / ~320 hours |
              <strong> Delivery:</strong> Remote | <strong>Credential:</strong> Certificate of Completion
            </p>
            <p>
              Occupational alignment includes Web Developers (O*NET-SOC 15-1254.00) and Graphic Designers
              (O*NET-SOC 27-1024.00), with demand alignment to local and statewide workforce pathways.
            </p>
            <ul>
              {webModules.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              <strong>Outcomes:</strong> responsive full-stack projects, portfolio-ready assets, design and
              media production, and interview-ready professional artifacts.
            </p>
          </article>

          <article className="career-card">
            <p className="career-card-kicker">Program 2</p>
            <h2>Applied Electronics, IoT and AI</h2>
            <p>
              <strong>Type:</strong> Non-credit occupational training | <strong>Duration:</strong> 16 weeks / ~320 hours |
              <strong> Delivery:</strong> Remote | <strong>Credential:</strong> Certificate of Completion
            </p>
            <p>
              Entry-to-intermediate technical pathway focused on electrical systems, IoT integration,
              applied AI, workforce readiness, and entrepreneurship execution.
            </p>
            <ul>
              {electronicsModules.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              <strong>Outcomes:</strong> IoT-enabled prototypes, AI-supported decision tools, team capstone,
              and career portfolio documentation.
            </p>
          </article>
        </section>

        <section className="career-grid" aria-label="Program operations and funding">
          <article className="career-card">
            <h2>Cost and Fee Structure</h2>
            <div className="career-table-wrap">
              <table className="career-table" aria-label="Program cost breakdown">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Range / Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Program Cost (Typical)</td>
                    <td>$3,600 - $3,800 per participant</td>
                  </tr>
                  <tr>
                    <td>Sliding Scale</td>
                    <td>$1,900 - $3,000</td>
                  </tr>
                  <tr>
                    <td>WIOA / Workforce-Funded</td>
                    <td>$0 - full approved amount</td>
                  </tr>
                  <tr>
                    <td>Payment Plan</td>
                    <td>3-4 installments</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="career-note">
              Optional add-ons can include cloud rendering, stock media, additional mentorship, and hardware support.
            </p>
          </article>

          <article className="career-card">
            <h2>Performance Metrics and Projections</h2>
            <ul>
              <li>Completion Rate target: 80%-85%</li>
              <li>Credential Attainment target: 75%-80%</li>
              <li>Q2 Employment/Entrepreneurship target: 70%-75%</li>
              <li>Q2 Median Earnings target: $14,000-$16,000 (role and pathway dependent)</li>
            </ul>
            <p>
              Outcomes are tracked with annual student data reporting and reviewed against workforce
              performance thresholds for ongoing ETPL alignment.
            </p>
          </article>
        </section>

        <section className="career-card career-wide" aria-label="Localized youth marketplace">
          <p className="career-card-kicker">Localized Marketplace for Youth Talent</p>
          <h2>Community-Linked Talent Pathways</h2>
          <p>
            Choicest Fruit is building a localized marketplace where trained youth apply technical skills to
            real local needs while gaining early entrepreneurial experience.
          </p>
          <Row className="g-3">
            {marketplaceTracks.map((track) => (
              <Col md={6} lg={4} key={track.title}>
                <div className="career-mini-card">
                  <h3>{track.title}</h3>
                  <p>{track.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </section>

        <section className="career-grid" aria-label="Compliance and outcomes">
          <article className="career-card">
            <h2>Policies and Compliance</h2>
            <ul>
              {policies.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Delivery and operations are designed for TWC and workforce-board review workflows,
              including annual maintenance and reporting requirements.
            </p>
          </article>

          <article className="career-card">
            <h2>Program Outcomes (No Guaranteed Claims)</h2>
            <ul>
              <li><strong>Skills students learn:</strong> coding, design, electronics, IoT, AI, and professional workflows</li>
              <li><strong>Projects students complete:</strong> portfolio projects, mini client work, and capstone</li>
              <li><strong>Career pathways:</strong> entry-level technical roles, apprenticeships, freelance work, entrepreneurship</li>
              <li><strong>Internship opportunities:</strong> structured pathways through partner and community projects</li>
              <li><strong>Portfolio opportunities:</strong> GitHub repositories, demos, and presentation-ready case studies</li>
            </ul>
            <p className="career-note">
              We do not promise guaranteed employment, salary, or certification outcomes.
            </p>
          </article>
        </section>

        <section id="enrollment-inquiry" className="career-card career-wide" aria-label="Enrollment inquiry form">
          <p className="career-card-kicker">Enrollment Inquiry</p>
          <h2>Request Program Information</h2>
          <p>
            Submit an inquiry and our team will follow up with admissions steps, cohort availability,
            and program-fit guidance.
          </p>
          <form className="career-form" onSubmit={(event) => event.preventDefault()}>
            <label>
              Name
              <input type="text" name="name" autoComplete="name" required />
            </label>
            <label>
              Email
              <input type="email" name="email" autoComplete="email" required />
            </label>
            <label>
              Phone
              <input type="tel" name="phone" autoComplete="tel" required />
            </label>
            <label>
              Program of Interest
              <select name="program" defaultValue="Web Development and Graphics Design" required>
                <option>Web Development and Graphics Design</option>
                <option>Applied Electronics, IoT and AI</option>
              </select>
            </label>
            <label className="career-form-wide">
              Questions
              <textarea name="questions" rows={4} placeholder="Tell us about your goals and timeline." />
            </label>
            <label className="career-checkbox">
              <input type="checkbox" name="scheduleCall" /> Schedule a call
            </label>
            <label className="career-checkbox">
              <input type="checkbox" name="requestCatalog" /> Request catalog
            </label>
            <div className="career-form-actions career-form-wide">
              <button type="submit" className="custom-yellow-btn btn">Submit Inquiry</button>
              <Link to="/admissions" className="btn btn-primary">Go to Admissions</Link>
            </div>
          </form>
        </section>
      </Container>
    </Container>
  );
}

export default Projects;
